import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m20 170 60-90 10 10 10-14 10 14 10-10 60 90z" }, null, -1),
    _createElementVNode("path", { d: "m78 82 12-42 10 20 12-30 10 52z" }, null, -1),
    _createElementVNode("circle", {
      cx: "86",
      cy: "48",
      r: "5"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "118",
      cy: "40",
      r: "4"
    }, null, -1)
  ]))]))
}
export default { render: render }